export const WEBSITE_SECTIONS = {
  PROFOLIO: 'profolio',
  LITE: 'lite',
};

export const PAGE_GROUPS = {
  DASHBOARD: 'dashboard',
  LISTINGS: 'listings',
  ADD_PROPERTY: 'add_property',
  MANAGE_LISTING: 'manage_listings',
  REPORTS: 'reports',
  SETTINGS: 'settings',
  AGENCY: 'agency',
  PACKAGES: 'packages',
  LEADS: 'leads', // Inbox
  HELP_CENTRE: 'help_centre',
  APP_REDIRECT: 'app_redirect',
  TRU_BROKER: 'tru_broker',
  CREDIT_USAGE: 'credit_usage',
  AGENCY_MANAGEMENT: 'agency_management',
  HEADER: 'header',
  CREATE_AD_LICENSE: "Create_AD_License",
  BAYUT_WORKSHOPS: 'bayut workshops',
  FEEDBACK: 'feedback',
};

export const PAGE_TYPES = {
  DETAILS: 'details',
  DASHBOARD: 'dashboard',
  CREDIT_USAGE: 'credit_usage',
  SUMMARY: 'summary',
  LEADS: 'leads',
  LISTINGS: 'listings',
  ACTIVE: 'active',
  DRAFT: 'draft',
  PENDING: 'pending',
  REMOVED: 'removed',
  AGENCY_STAFF: 'agency_staff',
  USER_SETTINGS: 'user_settings',
  AGENCY_SETTINGS: 'agency_settings',
  FAQ: 'faq',
  UPSELL: 'upsell',
  CHECKOUT: 'checkout',
  NAFATH: 'nafath',
  INBOX: 'inbox',
  HELP_CENTRE: 'help_centre',
  REGA_COMPLIANCE: 'rega_compliance',
  SIDE_MENU: 'side_bar',
  ACCOUNT_MANAGER: 'account_manager', // EMAIL, WHATSAPP, CALL Account Manager
  PROFOLIO: 'profolio', // HelpCenter
  DOWNLOAD_BUTTON: 'download_button',
  CHOOSE_LISTING_TYPE: 'choose_listing_type',
  CHOOSE_FAL_LICENSE: 'choose_fal_license',
  AD_LICENSE_VER: 'ad_license_verification',
  CR_VERIFICATION: 'cr_verification',
  NATIONAL_ID_VERIFICATION: 'national_id_verification',
  USER_PROFILE: 'user_profile',
  POST_LISTING: 'post_listing',
  ADD_PROPERTY_FORM: 'add_property_form',
  PACKAGES: 'packages',
  MANAGE_LISTING: 'manage_listings',
  HEADER: 'header',
  ACTIONS: 'actions',
  AGENCY_MANAGEMENT: 'agency_management',
  PERFORMANCE: 'performance',
  LEAD_DETAIL: 'lead_detail',
  LEAD_MANAGEMENT: 'lead_management',
  LEAD_DRAWER: 'lead_drawer',
  LEAD_TABLE: 'lead_table',
  CHECKOUT_PAGE: 'checkout_page',
};

export const PAGE_SECTIONS = {
  REGA_DETAILS: 'rega_details',
  NEW: 'new',
  EDIT: 'edit',
  REGA_QR: 'rega_qr',
  REGA_LINK: 'rega_link',
  MAP: 'map',
  TITLE: 'title',
  DESCRIPTION: 'description',
  CONFIRMATION_POPUP: 'confirmation_popup',
  EMAIL: 'email',
  WHATSAPP: 'whatsapp',
  CALL: 'call',
  PACKAGE_DURATION: 'package_duration',
  DELETE: 'delete',
  QUALITY: 'quality',
  UPGRADE_POPUP: 'upgrade_popup',
  PERFORMANCE: 'performance',
};

export const INTERACTED_FROM = {
  HEADER_PROFOLIO: 'header',
  HEADER_LITE: 'header_lite',
  SIDE_MENU: 'side_bar',
  ACCOUNT_SETTING: 'account_settings',
  MANAGE_LISTINGS: 'manage_listings',
  UPSELL: 'upsell',
  PACKAGED: 'packages',
  AD_LICENSE_SCREEN: "AD license screen",
  TRACK_AD_LICENSE_REQUESTS: "Track AD License requests",
};

// CATEGORY NAMES
export const EVENT_CATEGORIES = {
  ADD_PROPERTY_CAT: 'Add Property',
  UPDATE_PROPERTY_CAT: 'Update Property',
  PACKAGE_BUYING_CAT: 'Package Buying',
  PAGE_VIEW_SIDE_MENU_CAT: 'Page Views Side Menu',
  ACCOUNT_MANAGER_CAT: 'Account Manager',
  MANAGE_LISTING_CAT: 'Manage Listing',
  APP_REDIRECT: 'App Redirect',
  LEADS: 'Leads',
  CHECKOUT: 'Checkout',
  PROFILE_COMPLETION_CAT: 'Profile Completion',
  TRU_BROKER_CAT: 'TruBroker',
  SETTINGS: 'Settings',
  CREDIT_USAGE: 'Credit Usage',
  AGENCY_STAFF: 'Agency Staff',
  DASHBOARD: 'Dashboard',
  CREATE_AD_LICENSE: "Create AD License",
  EVENT_CHECKOUT: 'Event Checkout',
  LEAD_NUDGE_CAT: 'Lead Nudge',
  FEEDBACK_CAT: 'Feedback',
};

// ACTION NAMES
export const EVENT_NAMES = {
  ADD_PROPERTY_ACT: 'add_property',
  REGA_AD_VALIDATION_ACT: 'rega_ad_validation',
  PAGE_VIEW_ACT: 'page_view',
  CLICK_ACT: 'click_act',
  CLICK_MAP: 'click_map',
  IMAGE_UPLOAD_ACT: 'image_upload',
  MAP_PIN_SELECTED_ACT: 'select_map_pin',
  CONTENT_GENERATION_ACT: 'content_generation',
  GENERATE_TITLE_ACT: 'generate_title',
  GENERATE_DESCRIPTION_ACT: 'generate_description',
  SUBMIT_LISTING_ACT: 'submit_listing',
  UPSELL_SUBMIT_ACT: 'upsell_submit',
  PAY_CLICK_ACT: 'click_pay',
  VERIFY_NAFATH_CLICK_ACT: 'click_verify_nafath',
  GET_PACKAGE_ACT: 'get_package',
  BUY_PACKAGE_CTA_CLICKED: 'buy_package_cta_clicked',
  BUY_PACKAGE_MODAL_OPENED: 'buy_package_modal_opened',
  BUY_PACKAGE_FORM_STARTED: 'buy_package_form_started',
  BUY_PACKAGE_FORM_SUBMITTED: 'buy_package_form_submitted',
  BUY_PACKAGE_FORM_SUBMISSION_FAILED: 'buy_package_form_submission_failed',
  CLICK_UPGRADE_ACT: 'click_upgrade',
  UPGRADE_CONFIRM_ACT: 'upgrade_confirm',
  GET_TOPUP_ACT: 'get_topup',
  HELP_CENTRE_CLICK_ACT: 'click_help_centre',
  QUALITY_HOVER: 'quality_hover',
  DELETE_LISTING: 'delete_listing',
  SMART_BANNER_INSTALL_CLICK: 'click_smart_banner_install',
  DOWNLOAD_APP_CLICK: 'click_download_app',
  DOWNLOAD_APP_ACTION: 'download_app_action',
  CONFIRM_CLICK_ACT: 'click_confirm',
  COMPLETE_PROFILE_CLICK_ACT: 'complete_profile',
  WHY_IS_PROFILE_COMPLETION_IMPORTANT_ACT: 'learn_more',
  PROFILE_COMPLETION_POP_UP_CANCEL_ACT: 'profile_completed',
  START_TRUBROKER_JOURNEY_ACT: 'start_trubroker',
  TRUBROKER_LEARN_MORE_CLICK_ACT: 'tru_broker_learn_more',
  TRUBROKER_HOW_TO_EARN_TRUPOINTS_ACT: 'earn_trupoints',
  TRUBROKER_VIEW_LEADERBOARD_ACT: 'view_leaderboard',
  TRUBROKER_CANCEL_CLICK_ACT: 'tru_broker',
  SELECT_CATEGORY_ACT: 'select_category',
  UPGRADE_CLICK: 'click_upgrade',
  PACKAGE_DURATION: 'package_duration',
  MY_LISTINGS: 'my_listings',
  ADD_FILTER: 'add_filter',
  CLICK_ACTIONS: 'click_actions',
  EDIT_LISTING: 'edit_listing',
  USER_SETTINGS: 'user_settings',
  AGENCY_SETTINGS: 'agency_settings',
  SWITCH_PROFOLIO: 'switch_profolio',
  EDIT_STAFF: 'edit_staff',
  CONFIRM_EDIT_STAFF: 'confirm_edit_staff',
  DELETE_STAFF: 'delete_staff',
  CONFIRM_DELETE_STAFF: 'confirm_delete_staff',
  SELECT_AGENT: 'select_agent',
  SWITCH_CHART_VIEW: 'switch_chart_view',
  CHANGE_DATE: 'change_date',
  UPGRADE_LISTING: 'upgrade_listing',
  CLICK_LEAD: 'click_lead',
  FILTER_APPLIED: 'filter_applied',
  ADD_NAME: 'add_name',
  PLAY_RECORDING: 'play_recording',
  REPORTS_CLICK: 'reports_click',
  ADD_TASK: 'add_task',
  SUBMIT_TASK: 'submit_task',
  ADD_INTEREST: 'add_interest',
  ADD_INTEREST_CTA: 'add_interest_cta',
  VIEW_INTERESTS: 'view_interests',
  AMENITIES_EDIT: 'amenities_edit',
  CLICK_RENEW: 'click_renew',
  CLICK_FILTER: 'click_filter',
  UPDATE_LISTING_ACT: 'update_listing',
  CLICK_GET_AD_LICENSE: "click_get_ad_license",
  CLICK_CONTINUE_PAYMENT: "click_continue_payment",
  CLICK_CHECKOUT: "click_checkout",
  CLICK_TRACK_REQUESTS: "click_track_requests",
  CLICK_CONTACT: "click_contact",
  VIEW_AD: "view_ad_screen",
  VIEW_AD_FORM: "view_ad_form",
  VIEW_PAYMENT: "view_payment",
  VIEW_REQUEST_CONFIRMATION: "view_request_confirmation",
  SCROLL_50: "scroll_50",
  SCROLL_100: "scroll_100",
  CLICK_ON_PAY_NOW: "click_pay_now",
  APPLY_DISCOUNT: 'apply_discount',
  CLICK_MARKETING_BANNER: "click_marketing_banner",
  CLOSE_NUDGE: 'close_nudge',
  CLICK_NUDGE: 'click_nudge',
  FEEDBACK_OPEN: 'feedback_open',
  FEEDBACK_SUBMIT: 'feedback_submit',
};

export const statusMap = {
  10: PAGE_TYPES.ACTIVE,
  11: PAGE_TYPES.DRAFT,
  12: PAGE_TYPES.PENDING,
  13: PAGE_TYPES.REMOVED,
};

export const STRINGS = {
  NEW: 'new',
  EDIT: 'edit',
  ERROR: 'error',
  SUCCESS: 'success',
  YES: 'yes',
  NO: 'no',
  TRUE: 'true',
  FALSE: 'false',
};

export const getCommonParams = (user, packages = false, duration = false) => {
  return {
    website_section: !user?.is_package_user ? WEBSITE_SECTIONS.LITE : WEBSITE_SECTIONS.PROFOLIO,
    package_type: packages ? packages : user?.package ? user?.package?.slug : null,
    package_duration: duration ? duration : user?.package?.duration_in_months,
    is_agency: user?.agency ? true : false,
    agency_id: user?.agency ? user?.agency?.id : null,
    agency_name: user?.agency ? user?.agency?.name : null,
    is_package_user: user?.is_package_user ? 'yes' : 'no',
    impersonation: user?.impersonated,
  };
};

export const getPageType = (route) => {
  const matchingKey = Object.keys(PAGE_TYPES).find((key) => PAGE_TYPES[key] === route);
  if (matchingKey) {
    return PAGE_TYPES[matchingKey];
  }
  return PAGE_TYPES.DASHBOARD;
};
